module.exports = __webpack_public_path__ + "static/media/info.9b281cc1.svg";